<template>
  <div class="search-history-list">
    <title-chunk :title="title">
      <span slot="right" @click="onDelete" v-if="showAction">
        <!-- <van-icon class="delete-icon r" name="delete" /> -->
        <icon-font class="delete-icon r" icon-name="qingchubiaoqian" />
      </span>
      <LabelList
        :list="list"
        :labelsHeight="height"
        @update:labelsHeight="handleHeightChange"
        @onSelect="onSelect"
        :style="{ height: height, overflow: overflowValue }"
      />
      <template v-if="showBottom">
        <span class="more-search" v-if="showMore" @click="clickMore">
          {{ moreText }}
          <van-icon class="icon-arrow" name="arrow-down" />
          <!-- <van-icon class="icon-arrow" name="cap-arrow-down" /> -->
        </span>
        <span class="more-search" v-else @click="clickLess">
          {{ lessText }}
          <van-icon class="icon-arrow" name="arrow-up" />
          <!-- <icon-font class="icon-arrow" icon-name="shouqi" /> -->
        </span>
      </template>
    </title-chunk>
  </div>
</template>

<script>
import LabelList from './LabelList.vue';
import titleChunk from './titleChunk.vue';
import iconFont from '@/components/iconFont.vue';

export default {
  components: {
    LabelList,
    titleChunk,
    iconFont
  },
  data() {
    return {
      showBottom: false,
      showMore: false,
      overflowValue: 'hidden',
      height: 'auto'
    };
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    row: {
      type: Number,
      default: 2
    },
    title: {
      type: String,
      default: ''
    },
    moreText: {
      type: String,
      default: '更多'
    },
    lessText: {
      type: String,
      default: '收起'
    },
    showMoreHandler: {
      type: Boolean,
      default: false
    },
    showAction: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSelect(val) {
      this.$emit('onSelect', val);
    },

    onDelete() {
      this.$emit('onDelete');
    },

    clickMore() {
      this.showMore = false;
      this.height = 'unset';
      this.overflowValue = 'visible';
    },

    clickLess() {
      const limitHeight = this.row * 40;
      this.showMore = true;
      this.height = `${limitHeight}px`;
      this.overflowValue = 'hidden';
    },

    handleHeightChange(newVal) {
      if (!this.showMoreHandler) {
        return;
      }
      const limitHeight = this.row * 40;
      if (Number.parseInt(newVal, 0) > limitHeight) {
        this.showBottom = true;
        this.showMore = true;
        this.height = `${limitHeight}px`;
        this.overflowValue = 'hidden';
      }
    }
  }
};
</script>

<style lang="less">
.search-history-list {
  .icon-arrow {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }
  .more-search {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #bfbfbf;
    line-height: 1;
  }
  .delete-icon {
    width: 16px;
    height: 16px;
    color: #262626ff;
    &.r {
      float: right;
    }
  }

  .title-chunk h2 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
  }
}
</style>
